import React from 'react';
import Pagination from 'react-js-pagination';

export const PaginationShow = ({
    total, // Total number of items
    activePage, // Currently active page number
    handlePageChange, // Function to handle page change
    limit = 10, // Number of items to display per page (default is 10)
    range = 5, // Number of page numbers to display (default is 5)
}) => {
    return (
        <>
            {total >= limit && (
                <div className="Pagination">
                    {/* Render pagination only if total items exceed the limit */}
                    <Pagination
                        previousLabel="Previous"
                        nextLabel="Next"
                        activePage={activePage}
                        itemsCountPerPage={limit}
                        totalItemsCount={total}
                        pageRangeDisplayed={range}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                    />
                </div>
            )}
        </>
    );
};

// Example usage: if use same component the use this
{/* {total >= 10 ? (
    <div className="Pagination">
        <Pagination
            previousLabel="Previous"
            nextLabel="Next"
            activePage={activePage}
            itemsCountPerPage={10}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
        />
    </div>
) : null} */}

// In another component, you can use pagination like this:
// <PaginationShow total={total} activePage={activePage} handlePageChange={handlePageChange}/>